import SpanButton from './span-button';

export default SpanButton;
